"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Form = require("../../Form");
var _FormContext = require("../../Form/FormContext");
var _EditableTableContext = require("./EditableTableContext");
var _excluded = ["form", "formRef", "className"],
  _excluded2 = ["record", "index"];
function ConnectedEditableRow(_ref) {
  var form = _ref.form,
    formRef = _ref.formRef,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  formRef.current = form;
  className = 'editing-row ' + (className || '');
  return /*#__PURE__*/_react.default.createElement(_FormContext.FormProvider, {
    formContext: {
      form: form,
      showEllipsisTooltip: false
    }
  }, /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
    className: className
  }, rest)));
}
var EditableFormRow = _Form.Form.create()(ConnectedEditableRow);
function EditableRow(_ref2) {
  var record = _ref2.record,
    index = _ref2.index,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var _useEditableTableForm = (0, _EditableTableContext.useEditableTableForm)(),
    isRowEditing = _useEditableTableForm.isRowEditing,
    form = _useEditableTableForm.form,
    onFormValuesChange = _useEditableTableForm.onFormValuesChange;
  if (record && isRowEditing(record)) {
    return /*#__PURE__*/_react.default.createElement(EditableFormRow, (0, _extends2.default)({
      formRef: form,
      onValuesChange: onFormValuesChange && function (changedValues) {
        onFormValuesChange(changedValues, form);
      }
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement("tr", rest);
}